<template>
  <img src="../images/crypto-logo.png" alt="Cryptogra-HPI">
</template>
